import { Edit, useForm } from "@refinedev/antd";
import { HttpError } from '@refinedev/core';
import { Form, Input, Button } from "antd";
import { useState } from "react";
import { IconDisplay } from "../../components/IconDisplay";
import { ImageUpload } from "../../components/ImageUpload";

export function WorkoutPreferenceEdit() {
  const [showUpload, setShowUpload] = useState(false);

  const { formProps, saveButtonProps, query, formLoading } = useForm<any, HttpError, any>({
    resource: "workout_preference",
    successNotification: (data) => {
      return {
        message: data?.data.message,
        type: "success",
      };
    },
    action: "edit",
  });

  const preference = query?.data?.data?.data;
//   console.log("Offer:", preference)

  return (
    <Edit
      saveButtonProps={saveButtonProps}
      isLoading={formLoading}
      resource="workout_preference"
      mutationMode="optimistic"
      title="Edit Offer"
    >
      <Form 
        {...formProps} 
        layout="vertical"
      >
        <Form.Item
          label="Name"
          name={["name"]}
          initialValue={preference?.name}
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Description"
          name={["description"]}
          initialValue={preference?.description}
          rules={[{ required: true }]}
        >
          <Input.TextArea />
        </Form.Item>

        <Form.Item
          label="Icon"
          name="iconID"
          initialValue={preference?.iconID}
        >
          {!showUpload ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <IconDisplay iconURL={preference?.iconURL} />
              <Button onClick={() => setShowUpload(true)}>Change Icon</Button>
              <Button
                onClick={() => {
                  formProps.form?.setFieldsValue({ iconID: null });
                  setShowUpload(true);
                }}
                disabled={!preference?.iconID}
              >
                Remove Icon
              </Button>
            </div>
          ) : (
            <ImageUpload />
          )}
        </Form.Item>
      </Form>
    </Edit>
  );
}
